import inputIsActive from './inputIsActive';
export const isConditionallyRequired = (element, conditionalRequirements) => {
  const requirement = element.get('IsConditionallyRequired');
  if (conditionalRequirements.get(requirement)) {
    return true;
  }
  return false;
};
const inputIsRequired = (element, coApplicantIsActive, conditionalRequirements) => {
  const active = inputIsActive(element, coApplicantIsActive);
  if (active) {
    if (Boolean(element.get('IsRequired'))) {
      return true;
    }
    if (Boolean(element.get('IsConditionallyRequired'))) {
      return isConditionallyRequired(element, conditionalRequirements);
    }
  }
  return false;
};
export default inputIsRequired;